import { GWidget } from "./GWidget";
import { Input } from "../display/Input";
import { HideFlags } from "../Const";
import { TransformKind } from "../display/SpriteConst";
import { Event } from "../events/Event";
import { Translations } from "./Translations";
export class GTextInput extends GWidget {
    constructor() {
        super();
        this.textIns = new Input();
        this.textIns.hideFlags |= HideFlags.HideAndDontSave;
        this.textIns.overflow = "hidden";
        this.textIns.padding.fill(2);
        this.textIns._onTranslate = (text, options, role) => role === 1 ? Translations.translate(text, options) : text;
        this.textIns.on(Event.INPUT, () => this.event(Event.INPUT));
        this.textIns.on(Event.ENTER, () => this.event(Event.ENTER));
        this.textIns.on(Event.CHANGE, () => this.event(Event.CHANGE));
        this.textIns.on(Event.FOCUS, () => this.event(Event.FOCUS));
        this.textIns.on(Event.BLUR, () => this.event(Event.BLUR));
        this.addChild(this.textIns);
    }
    get text() {
        return this.textIns.text;
    }
    set text(value) {
        this.textIns.text = value;
    }
    get font() {
        return this.textIns.font;
    }
    set font(value) {
        this.textIns.font = value;
    }
    get fontSize() {
        return this.textIns.fontSize;
    }
    set fontSize(value) {
        this.textIns.fontSize = value;
    }
    get color() {
        return this.textIns.color;
    }
    set color(value) {
        this.textIns.color = value;
    }
    get bold() {
        return this.textIns.bold;
    }
    set bold(value) {
        this.textIns.bold = value;
    }
    get italic() {
        return this.textIns.italic;
    }
    set italic(value) {
        this.textIns.italic = value;
    }
    get align() {
        return this.textIns.align;
    }
    set align(value) {
        this.textIns.align = value;
    }
    get valign() {
        return this.textIns.valign;
    }
    set valign(value) {
        this.textIns.valign = value;
    }
    get leading() {
        return this.textIns.leading;
    }
    set leading(value) {
        this.textIns.leading = value;
    }
    get padding() {
        return this.textIns.padding;
    }
    set padding(value) {
        this.textIns.padding = value;
    }
    get underline() {
        return this.textIns.underline;
    }
    set underline(value) {
        this.textIns.underline = value;
    }
    get underlineColor() {
        return this.textIns.underlineColor;
    }
    set underlineColor(value) {
        this.textIns.underlineColor = value;
    }
    get strikethrough() {
        return this.textIns.strikethrough;
    }
    set strikethrough(value) {
        this.textIns.strikethrough = value;
    }
    get strikethroughColor() {
        return this.textIns.strikethroughColor;
    }
    set strikethroughColor(value) {
        this.textIns.strikethroughColor = value;
    }
    get stroke() {
        return this.textIns.stroke;
    }
    set stroke(value) {
        this.textIns.stroke = value;
    }
    get strokeColor() {
        return this.textIns.strokeColor;
    }
    set strokeColor(value) {
        this.textIns.strokeColor = value;
    }
    get multiline() {
        return this.textIns.multiline;
    }
    set multiline(value) {
        this.textIns.multiline = value;
    }
    get editable() {
        return this.textIns.editable;
    }
    set editable(value) {
        this.textIns.editable = value;
    }
    get restrict() {
        return this.textIns.restrict;
    }
    set restrict(pattern) {
        this.textIns.restrict = pattern;
    }
    get prompt() {
        return this.textIns.prompt;
    }
    set prompt(value) {
        this.textIns.prompt = value;
    }
    get promptColor() {
        return this.textIns.promptColor;
    }
    set promptColor(value) {
        this.textIns.promptColor = value;
    }
    get maxChars() {
        return this.textIns.maxChars;
    }
    set maxChars(value) {
        this.textIns.maxChars = value;
    }
    get type() {
        return this.textIns.type;
    }
    set type(value) {
        this.textIns.type = value;
    }
    focus() {
        this.textIns.focus = true;
    }
    blur() {
        this.textIns.focus = false;
    }
    _transChanged(kind) {
        super._transChanged(kind);
        if ((kind & TransformKind.Size) != 0) {
            this.textIns.size(this.width, this.height);
        }
    }
}
